import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PatientVitalMst, PatientVitalData, FetusVitalMaster } from '../../../interfaces/masters/patientvital';
import { PatientvitalApi } from '../api/patientvital.api';




@Injectable()
export class PatientvitalService extends PatientVitalData {

  private postHeightChartData = new BehaviorSubject<string>("");
  public heightChartData = this.postHeightChartData.asObservable();
  private postWeightChartData = new BehaviorSubject<string>("");
  public weightChartData = this.postWeightChartData.asObservable();
  private postHcChartData = new BehaviorSubject<string>("");
  public hcChartData = this.postHcChartData.asObservable();
  constructor(private api: PatientvitalApi) {
    super();
  }
  list(url: string): Observable<PatientVitalMst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientVitalMst>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientVitalMst): Observable<PatientVitalMst> {
    return this.api.add(url,data);
  }
  createFetusVital(url: string, data: FetusVitalMaster): Observable<FetusVitalMaster> {
    return this.api.addFetusVital(url, data);
  }
  
  update(url: string, data:PatientVitalMst): Observable<PatientVitalMst> {
    return this.api.update(url,data);
  }
  updateFetusVital(url: string, data: FetusVitalMaster): Observable<FetusVitalMaster> {
    return this.api.updateFetusVital(url, data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
  listForDoctorQueue(url: string, data: any): Observable<any>
  {
    return this.api.listForDoctorQueue(url, data);
  }

  setHeightChart(data: string): void{
    this.postHeightChartData.next(data);
    
  }
  setWeightChart(data: string): void{
    this.postWeightChartData.next(data);
    
  }
  setHcChart(data: string): void{
    this.postHcChartData.next(data);
    
  }

}
